import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router} from "react-router-dom";
import './index.css';
import './assets/base.scss';
//import App from './App';
import App2 from './screens/router/routerContainer';
import reportWebVitals from './reportWebVitals';
import Auth0ProviderWithHistory from "./auth/auth0-provider-with-history";

ReactDOM.render(
  <Router >
      <Auth0ProviderWithHistory>
        <App2 />
      </Auth0ProviderWithHistory>
  </Router >,
    document.getElementById("root")
  );
reportWebVitals();
